import { BASE_URL, CORPORATE_COMPETENCY } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";

export async function getCorporateCompetencies(
  params: string = ""
): Promise<any[]> {
  const response = await axios.get(BASE_URL + CORPORATE_COMPETENCY + params);
  return response.data;
}
export async function addCorporateCompetencies(data: {name:string,nameAr:string}[]) {
  const response = await axios.post(BASE_URL + CORPORATE_COMPETENCY, data);
  return response.data;
}

export async function editCorporateCompetencies(
  data: any,
  id: string
) {
  const response = await axios.patch(
    BASE_URL + CORPORATE_COMPETENCY + "/" + id,
    data
  );
  return response.data;
}

export async function deleteCorporateCompetencies(id: string) {
  const response = await axios.delete(BASE_URL + CORPORATE_COMPETENCY + "/" + id);
  return response.data;
}

export const CorporateCompetencyCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },

  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
